<template>
  <div class="bmui-field_arrow1">
    <p class="bmui-field_arrow1-title">{{ title || 'TITLE' }}<span v-show="isNeed" class="bmui-field_arrow1-isNeed">*</span></p>
    <p
      class="bmui-field_arrow1-content"
      :class="{ 'bmui-field_arrow1-empty': !content }">{{ content || placeholder || '请选择' }}</p>
    <i class="bmui-field_arrow1-icon"/>
  </div>
</template>
<script>
import MixinInput from '../mixins/input'
export default {
  name: 'BmuiFieldArrow1',
  mixins: [MixinInput],
  props: {
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isNeed: {
      type: Boolean,
      default: false
    }
  }
}
</script>
